<template>
  <Card>
    <p slot="title"> Tambah Pending Dana</p>

    <Button
        :disabled="!isDataEdited"
        type="success"
        slot="extra"
        size="small"
        @click="actionPost">Simpan Data</Button>

    <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
      <Col span="8">
        <Select v-model="bankAccountId"
          placeholder="Pilih Bank"
          clearable
          filterable >
              <Option
                  v-for="bankAccount in bankAccounts"
                  :value="bankAccount.id"
                  :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
        </Select>
      </Col>

      <Col span="2">
        <DatePicker type="year" placeholder="Pilih Tahun" v-model="yearSelect" />
      </Col>

      <Col span="9">
        <Select v-model="ntTypeSelected"
          placeholder="Pilih Tipe Mutasi"
          clearable
          filterable
          style="width: 180px;">
              <Option
                  v-for="type in ntTypes"
                  :value="type.value"
                  :key="type.value">{{ type.value }}</Option>
        </Select>
      </Col>

      <Col span="3" align="right">
        <p style="margin-top: 5px;">Max. 100 baris</p>
      </Col>
    </Row>

    <br />

    <div>
        <HotTable
          ref="hotTableComponent"
          :settings="hotSettings">
        </HotTable>
    </div>
  </Card>

</template>

<script>
  import {HTTP} from '@/components/http-lib'
  import moment from 'moment'
  import Handsontable from "handsontable";
  import { HotTable } from '@handsontable/vue';
  import { registerAllModules } from "handsontable/registry";

  registerAllModules();

  import "handsontable/dist/handsontable.full.min.css";

  const errorData = [];
  const monthNames = [{ id: 1, name: 'Jan', month: 'January'}, { id: 2, name: 'Feb', month : 'February'}, { id: 3, name: 'Mar', month : 'Maret'}, { id: 4, name: 'Apr', month : 'April'},
  { id: 5, name: 'Mei', month : 'May' }, { id: 6, name: 'Jun', month : 'June'}, { id: 7, name: 'Jul', month : 'July' }, { id: 8, name: 'Ags', month : 'August'}, { id: 9, name: 'Sep', month : 'September'}, { id: 10, name: 'Okt', month : 'October'},
  { id: 11, name: 'Nov', month : 'November'}, { id: 12, name: 'Des', month : 'December'}];


  export default {
    data () {
      return {
        tableData: {
          type: Array
        },
        isDataEdited: false,
        bankAccountId: null,
        bankAccounts: [],
        errorData: [],
        yearSelect: null,
        hotSettings: {
          licenseKey: "non-commercial-and-evaluation",
          height: 600,
          width: "100%",
          stretchH: "all",
          filters: true,
          autoColumnSize: true,
          autoRowSize: true,
          colHeaders: true,
          rowHeaders: true,
          colWidths: [100, 500, 100, 200, 200],
          colHeaders: [
            "Tanggal Mutasi",
            "Keterangan",
            "Mutasi",
            // "Saldo"
          ],
          minCols: "5",
          maxCols: "5",
          minRows: "100",
          maxRows: "100",
          columns: [
            {
              data: "tanggal",
              type: "date",
              dateFormat: 'DD-MMMM',
              correctFormat: false,
            },
            {
              data: "keterangan",
              type: "text",
              allowEmpty: false,
            },
            { data: "mutasi",
              type: "text",
              allowEmpty: false,
              numericFormat: {
                pattern: "0,0",
              },
            },
            // { data: "saldo",
            //   type: "text",
            //   allowEmpty: false,
            //   numericFormat: {
            //     pattern: "0,0",
            //   },
            // },
          ],
          afterChange: (changes) => {
            const hot = this.$refs.hotTableComponent.hotInstance;
            if (changes) {
              changes.forEach((change) => {
                console.log(change)
                var row = change[0];

                let data = hot.getDataAtRow(row);
                let isNull = data.every(_.isNull);

                for(let i=0; i<5; i++){
                  if(isNull) {
                    hot.setCellMeta(row, i, 'className', 'default-bg');
                  } else {
                    // if((data[i] == null || data[i] == '' ) && (i == 0 || i == 1 || i == 3)) {
                    //   hot.setCellMeta(row, i, 'className', 'warning-bg');
                    // } else {
                    //   hot.setCellMeta(row, i, 'className', 'default-bg');
                    // }
                  }
                  hot.render();
                }

                for(let i=0; i<5; i++){
                  // if(data[i] == null && (i == 0 || i == 1 || i == 3)) {
                  //   this.isDataEdited = false
                  //   break;
                  // }

                  this.isDataEdited = true
                }

                let alldata = hot.getData();
                let isAllNull = alldata.every(_.isNull);

                if(isNull && isAllNull) {
                  this.isDataEdited = true
                }
              })
            }
            // let row = changesDataCell.value[0][0];
            // let col = hot.propToCol(changesDataCell.value[0][1]);



            // for(let i=0; i<5; i++){
            //   hot.getDataAtCell(row, "id");
            //   hot.setCellMeta(row, col, 'className', 'lightblue-bg');
            // }
          },
        },
        // ntTypes : [
        //   { value: "MUTASI" },
        //   { value: "GIRO" }
        // ],
        ntTypes : [
          { value: "MUTASI" }
        ],
        ntTypeSelected : "MUTASI"
      }
    },
    components: {
      HotTable
    },
    methods: {
      actionPost() {
        const hot = this.$refs.hotTableComponent.hotInstance;
        this.tableData = hot.getData();

        let payload = [];
        let idx = -1;
        let year = moment(this.yearSelect, 'YYYY-MM-DD').format("YYYY");

        if(this.bankAccountId == null){
          // this.bankAccountId = 1;

          // mandatory bank account
          this.$Notice.warning({
              title: "Perhatian",
              desc: "Silahkan pilih bank terlebih dahulu !",
              duration: 3
          });
          return false
        }

        hot.getData().forEach((data) => {
          console.log(data[0]);
          if(data[0] != null && data[0] != '' && data[1] != null && data[1] != '') {
            let mutasi = null;
            let saldo = null;
            let month = data[0].split("-");

            if (monthNames.find(x => x.name == month[1])) {
              data[0] = month[0] + "-" + monthNames.find(x => x.name == month[1]).month;
            }

            if (data[0] == "PEND") {
              data[0] = new Date();
            }

            if (data[2]) {
              mutasi = data[2].replaceAll(',', '');
            }

            // if (data[3]) {
            //   saldo = data[3].replaceAll(',', '')
            // }

            let pending = {
                bankAccountId: this.bankAccountId,
                tanggal : data[0] + "-" + year,
                keterangan : data[1],
                mutasi : mutasi,
                saldo : saldo,
                ntType : this.ntTypeSelected
            }
            payload.push(pending)

            idx ++;
          } else if ((data[0] == null || data[0] == '') && data[1] != null) {
            payload[idx].mutasi = payload[idx].mutasi + data[2];
            payload[idx].keterangan = payload[idx].keterangan + ", " + data[1];
          }
        })

        HTTP
        .post('paymentPending/importFromArray', {
            payload
        })
        .then(response => {
            console.log(response)

            this.$Message.success({
                content: 'Pending List Saved',
                duration: 3
            });
        })
        .catch(e => {
            this.loadingPost = false
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })

        // const hot = this.$refs.hotTableComponent.hotInstance;
        // this.tableData = hot.getData();
        // this.checkTableData();
        // this.isLoadingPostVideo = true;
        // this.tableError = null;
        // return this.postDouyinVideo(this.dataPayload)
        //   .then((res) => {
        //     this.isSuccess = true;
        //     this.isLoadingPostVideo = false;
        //     setTimeout(() => {
        //       this.$router.push({ name: "listDouyin" });
        //     }, 3000);
        //   })
        //   .catch((err) => {
        //     this.isError = true;
        //     this.errorMessage = err.response.data;
        //     this.isLoadingPostVideo = false;
        //     if (err.response.data.code == 4200) {
        //       this.tableError = err.response.data.data;
        //       this.cellMeta.push({
        //         row: err.response.data.data.row,
        //         col: 1,
        //         className: "red",
        //       });
        //     }
        //   });
      },
      getBankAccount: function() {
      // this.loadingSearch  = true;
        HTTP.get("bankAccount/findAll/active")
          .then(response => {
            this.bankAccounts = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
      },
      afterValidate(item) {
        this.errorData = item;
        setTimeout(() => {
          this.checkTableData();
        }, 100);
      },
      checkTableData() {
        this.cellMeta = [];
        this.isDataEdited = true;
        let data = [];

        for (let i = 0; i < this.tableData.length; i++) {
          const e = this.tableData[i];
          console.log(this.tableData[i])
          data.push({
            ...e,
            username: e.username
              ? /^[0-9]*$/.test(e.username)
                ? `${e.username.slice(0, 19)}k`
                : e.username.slice(0, 20)
              : "",
            row: i,
          });
        }
        const filtered = data.filter((item) => {
          if (Object.keys(item).length <= 2 && Object.keys(item).length > 1) {
            console.log({ item });
          }
          return Object.keys(item).length > 2;
        });
        this.dataPayload = filtered.filter((item) => {
          return (
            item.tanggal != "" &&
            item.keterangan != "" &&
            item.mutasi != "" &&
            // item.saldo != "" &&
            item.tanggal != null &&
            item.keterangan != null &&
            item.mutasi != null
            // item.saldo != null
          );
        });
      },
    },
    components: {
      HotTable
    },
    created() {
      this.getBankAccount();
      this.yearSelect = moment().format('ddd MMM DD YYYY HH:mm:ss [GMT]Z (ZZ)')
    }
}
</script>

<style>
  .handsontable .warning-bg {
    background-color: yellow;
  }
  .handsontable .default-bg {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// PendingFunds.vue?509e7fcc